import { Link } from "react-router-dom";

const CurrencyConverterContentThree = () => {
  return (
    <div className="how__work__resource">
      <div className="container">
        <div className="row">
          <div className="col-lg-6 col-md-12 col-sm-12 col-12">
            <div className="content-left">
              <h2>Real-Time Data. Real-World Value.</h2>
              <p>
                With The Pips Currency Converter, you’re always one step ahead.
                By accessing up-to-date exchange rates, you can identify
                opportunities, plan your trades efficiently, and minimize
                uncertainty in global transactions.
              </p>
              <Link
                className="slide__btn dg__btn"
                to={process.env.PUBLIC_URL + "/company/contact"}
              >
                Start Converting
              </Link>
            </div>
          </div>
          <div className="col-lg-6 col-md-12 col-sm-12 col-12 sm__mt--40 md__mt--40">
            <div className="thumb-right">
              <img
                src={process.env.PUBLIC_URL + "/images/resources/currency_converter/currency_converter_3.png"}
                alt="computer images"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CurrencyConverterContentThree;
